module.exports = __webpack_public_path__ + "static/media/heart-fav.0ff4dabf.svg";